// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604171233/js/" + chunkId + "." + {"44":"db8802d9","225":"5cec0754","481":"b5e963a7","486":"b0d045c3","770":"c6f1fc12"}[chunkId] + ".0.2947642756277642.chunk.js";
};